import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { INotes, INotesForDropdown, IUpdateNotes } from './notes-model';

@Injectable()
export class NotesService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${NotesService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/notes';

    public getNotes(): Observable<SuccessResponse<INotes> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<INotes>>(NotesService.URL).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateNotes(model: IUpdateNotes): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(NotesService.URL, model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getNotesForDropdown(): Observable<SuccessResponse<INotesForDropdown> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<INotesForDropdown>>(NotesService.URL + '/dropdowns').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
